import appBasicPlan from "../../views/appPlans/basic.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("basicplan", {
    url: "basicplan/:id",
    parent: "app",
    views: {
      view: {
        template: appBasicPlan,
      },
    },
    reloadOnSearch: false,
    data: { title: "Basic Plan" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/basicPlan/basicPlan.urls.js